<template>
  <VTooltip left>
    <template v-slot:activator="{ on, attrs }">
      <VBtn
        color="#757575"
        text
        v-bind="attrs"
        v-on="on"
      >
        计算规则
        <VIcon
          
          dark
          v-bind="attrs"
          small
          v-on="on"
        >
          mdi-information
        </VIcon>
      </VBtn>
    </template>
    <span>按付款时间统计现金收入</span>
  </VTooltip>
</template>
<script>

  export default {

  }
</script>
